import { useInstancesByQuery } from 'hive-react-utils';
import _ from 'lodash';
import { useEffect, useState } from 'react';
export function useMyPatientPriorityResponses(patientID, startTime, endTime) {
    const rawPriorities = useInstancesByQuery('ecarepd', 'getPatientPriorityResponseByPatientIDAndDate', 'patientPriorityResponse', {
        // Give a little debounce to prevent jerkiness while a survey is saved (multiple items usually)
        debounce: true,
        debounceWait: 1000,
    }, patientID, startTime, endTime);
    // Make sure we ignore pending status
    const [priorities, setPriorities] = useState([]);
    useEffect(() => {
        if (!rawPriorities ||
            _.get(rawPriorities, 'status') !== "done" /* ContentObserver.status.DONE */) {
            return;
        }
        setPriorities(rawPriorities);
    }, [rawPriorities]);
    return priorities;
}
